<template>
<div class="sidebar-menu-group">
    <div :class="['menu-group-main', isShowSubmenu ? 'is_open' : '', currentMenuUrl === info.url ? 'is_active' : '']" @click="toggleSubmenu">
        <a v-if="info.name != ''" class="menu-group-info" :href="info.url ?? 'javascript:void(0);'" target="_self">
            <div class="menu-group-left">
                <div v-if="typeof(info.icon_normal)!= 'undefined'" class="menu-group-icon">
                    <img class="menu-icon-img" :src="getMenuImg(info.icon_normal)" alt="">
                    <img class="menu-icon-img menu-icon-img-act" :src="getMenuImg(info.icon_active)" alt="">
                </div>
                <div v-if="open" class="menu-group-name"><span>{{ info.name }}</span>
                    <!-- <img v-if="info.is_new" class="new_icon" src="@/assets/index/img/ucenter/menu_left/new_icon.svg" alt=""> -->
                </div>
            </div>
            <div v-if="subMenus.length > 0 && open" class="menu-group-arrow">
                <img class="menu-arrow" src="@/assets/index/img/ucenter/sidebar/icon_group.png" alt="arrow">
            </div>
        </a>
    </div>
    <div :class="['menu-group-sub', (isShowSubmenu && subMenus.length > 0) ? '!block' : 'hidden']">
        <ul v-for="item in subMenus" class="menu-group-sub-ul">
            <li :class="['menu-group-sub-li', item.url === currentMenuUrl ? 'is_active' : '']">                
                <router-link :to="item.url" class="submenu-group-info" :href="item.url" :target="item.target ?? '_self'">
                    <div class="submenu-item-icon">
                        <img class="menu-icon-img" :src="getMenuImg(item.icon_normal)" alt="">
                        <img class="menu-icon-img menu-icon-img-act" :src="getMenuImg(item.icon_active)" alt="">
                    </div>
                    <span v-if="open">{{ item.name }}</span>
                </router-link>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    name: 'UserCenterSideMenuGroup',
    data() {
        return {
            isShowSubmenu: true,
        }
    },
    props: {
        info: {
            type: Object,
            default: () => {return {'name': '', 'url': '', icon_normal: '', icon_active: '' }},
        },
        subMenus: {
            type: Array,
            default: () => [], // {name: '', url: '', icon_normal: '', icon_active: '', is_new: false}
        },
        currentMenuUrl: {
            type: String,
            default: '',
        },
        open: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        getMenuImg(area) {
            if (area) {
                return require(`@/assets/index/img/ucenter/sidebar/${area}`);
            }    
            return '';
        },
        
        toggleSubmenu() {
            if (this.open) {
                this.isShowSubmenu = !this.isShowSubmenu;
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.sidebar-menu-group {
    width: 100%
}

.sidebar-menu-group .menu-group-main {
    width: 100%;
    height: 48px;
    padding: 0 0px;
    box-sizing: border-box;
    border-radius: 8px
}

.sidebar-menu-group .menu-group-main .menu-group-info {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: "Poppins-SemiBold";
    font-weight: 500;
    color: #12182C;
    line-height: 1.2;
    text-decoration: none
}

.sidebar-menu-group .menu-group-main .menu-group-info .menu-group-left {
    display: flex;
    justify-content: flex-start
}

.sidebar-menu-group .menu-group-main .menu-group-info .menu-group-left .menu-group-icon {
    padding-left: 10px;
    padding-right: 10px;
}

.sidebar-menu-group .menu-group-main .menu-group-info .menu-group-left .menu-group-icon .menu-icon-img {
    display: block
}

.sidebar-menu-group .menu-group-main .menu-group-info .menu-group-left .menu-group-icon .menu-icon-img.menu-icon-img-act {
    display: none
}

.sidebar-menu-group .menu-group-main:hover .menu-group-info {
    color: #3B6CF4
}

.sidebar-menu-group .menu-group-main:hover .menu-group-info .menu-group-left .menu-group-icon .menu-icon-img {
    display: none
}

.sidebar-menu-group .menu-group-main:hover .menu-group-info .menu-group-left .menu-group-icon .menu-icon-img.menu-icon-img-act {
    display: block
}

.sidebar-menu-group .menu-group-main .menu-group-info .menu-group-arrow .menu-arrow {
    transform: rotate(180deg);
    transition: all 0.3s
}

.sidebar-menu-group .menu-group-main.is_active {
    background-color: #e5ebf1
}

.sidebar-menu-group .menu-group-main.is_active .menu-group-info {
    color: #3B6CF4;    
}

.sidebar-menu-group .menu-group-main.is_active .menu-group-info .menu-group-arrow .menu-arrow {
    transform: rotate(360deg)
}

.sidebar-menu-group .menu-group-main.is_open .menu-group-info .menu-group-arrow .menu-arrow {
    transform: rotate(360deg)
}

.sidebar-menu-group .menu-group-main:is_active .menu-group-info .menu-group-left .menu-group-icon .menu-icon-img {
    display: none
}

.sidebar-menu-group .menu-group-main:is_active .menu-group-info .menu-group-left .menu-group-icon .menu-icon-img.menu-icon-img-act {
    display: block
}

.menu-group-sub {
    width: 100%;
    padding: 0 0 0 0px;
    box-sizing: border-box
}

.menu-group-sub .menu-group-sub-ul {
    width: 100%;
    padding: 0 0 0 0px;
    box-sizing: border-box;    
    list-style-type: none;
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li {
    position: relative;
    width: 100%;
    height: 36px;
    padding-left: 0px;
    border-radius: 4px 4px 4px 4px;
    box-sizing: border-box;
    line-height: 36px
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li .submenu-item-icon {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translate(-50%, -50%);    
    display: block;
    width: 18px;
    height: 18px;    
    flex-shrink: 0;
    border-radius: 1px 1px 1px 1px
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li .submenu-group-info {
    display: block;
    width: 100%;
    height: 100%;
    padding-left: 38px;
    line-height: 36px;    
    font-size: 14px;
    font-family: "Poppins-Medium";
    font-weight: 500;
    color: #636466;
    text-decoration: none
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li .submenu-item-icon .menu-icon-img {
    display: block;
    width: auto;
    height: 18px
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li .submenu-item-icon .menu-icon-img.menu-icon-img-w {
    width: 18px;
    height: auto
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li .submenu-item-icon .menu-icon-img.menu-icon-img-act {
    display: none
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li .submenu-item-icon .menu-group-arrow {
    flex-shrink: 0
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.is_active .submenu-item-icon .menu-icon-img {
    display: none
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.is_active .submenu-item-icon .menu-icon-img.menu-icon-img-act {
    display: block
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li:hover {
    background-color: #e5ebf1
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li:hover .submenu-group-info {
    color: #3B6CF4
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.hover .submenu-item-icon .menu-icon-img {
    display: none
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.hover .submenu-item-icon .menu-icon-img.menu-icon-img-act {
    display: block
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.is_active {
    background-color: #e5ebf1
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.is_active::before {
    content: "";
    width: 2px;
    height: 80%;
    background-color: #3B6CF4;
    position: absolute;
    top: 50%;
    left: -20px;
    transform: translate(-100%, -50%)
}

.menu-group-sub .menu-group-sub-ul .menu-group-sub-li.is_active .submenu-group-info {
    color: #3B6CF4
}
</style>